import React from "react"
import { graphql, useStaticQuery } from "gatsby";
import Img from "gatsby-image";

function EasySection({ title, subtitle }) {
  const data = useStaticQuery(graphql`
  query {
    file(relativePath: { eq: "assets/caught.png" }) {
      childImageSharp {
        fluid(maxWidth: 520) {
          ...GatsbyImageSharpFluid
        }
      }
    }
  }
`)
  return (<div className="section section-screenshot">
    <div className="container">
      <h2>{title || <span>Catch your<br />Fake Friends</span>}</h2>
      <div className="subtitle">{subtitle || "Call out your fake friends when they don't click on the links you send them."}</div>
      <div className="section-image screenshot">
        <Img style={{ marginTop: "40px" }} fluid={data.file.childImageSharp.fluid} />
      </div>
    </div>
  </div>
  );
}

export default EasySection;